module.exports = __webpack_public_path__ + "1d5f9a3780d001a6e3d4083baf72e2f6.png";